import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import { PaymentScheduleCard } from "./component";
import { selectRoomType } from "../../../shop/actions/actions";
import {
  getIsChosenRoomPayLater,
  getPremierCollectionShopChosenProductIndex,
  getPremierCollectionShopChosenRoomInfo,
  getPremierCollectionShopChosenRoomInfoIndex,
} from "../../../shop/reducer";
import { getSelectedAccount } from "../../../rewards/reducer";
import { schedulePriceQuote } from "../../actions/actions";
import { getAllAncillaries } from "../../../ancillary/reducer";
import { getTotalToPay, getTotalVacationRentalsToPay } from "../../reducer";
import { getVacationRentalShopSelectedListing } from "../../../vacation-rental-shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedHome = getVacationRentalShopSelectedListing(state);

  return {
    chosenRoomInfoIndex: getPremierCollectionShopChosenRoomInfoIndex(state),
    chosenProductIndex: getPremierCollectionShopChosenProductIndex(state),
    chosenRoomInfo: getPremierCollectionShopChosenRoomInfo(state),
    isPayLater: getIsChosenRoomPayLater(state),
    selectedAccount: getSelectedAccount(state),
    ancillaries: getAllAncillaries(state),
    tripTotal: selectedHome
      ? getTotalVacationRentalsToPay(state)
      : getTotalToPay(state),
  };
};

const mapDispatchToProps = {
  selectRoomType,
  schedulePriceQuote,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PaymentScheduleCardProps = ConnectedProps<typeof connector>;

export const ConnectedPaymentScheduleCard = withRouter(
  connector(PaymentScheduleCard)
);
